export default {
  // 页面标题
  pageTitle: "AhaCreator DNA",
  
  // 当前网站部分
  currentWebsite: {
    label: "当前网站",
    startButton: "开始塑造 AhaCreator DNA"
  },
  
  // 业务名称
  businessName: {
    title: "业务名称",
    edit: "编辑",
    save: "保存"
  },
  
  // 业务介绍
  businessIntroduction: {
    title: "业务介绍",
    edit: "编辑",
    save: "保存"
  },
  
  // 竞争对手
  competitors: {
    title: "竞争对手",
    edit: "编辑",
    save: "保存"
  },
  
  // 品牌形象
  brandImage: {
    title: "品牌形象",
    edit: "编辑",
    save: "保存"
  },
  
  // 语调
  toneOfVoice: {
    title: "品牌语调",
    edit: "编辑",
    save: "保存",
    newTag: "新标签"
  },
  
  // 核心卖点
  coreSellingPoints: {
    title: "核心卖点",
    edit: "编辑",
    save: "保存",
    add: "添加",
    addWithCount: "添加 ({count})"
  },
  
  // 核心受众
  coreAudiences: {
    title: "核心受众",
    edit: "编辑",
    save: "保存",
    add: "添加",
    titlePlaceholder: "标题",
    contentPlaceholder: "内容"
  },
  
  // 加载状态
  loading: "加载中...",
  
  // 通用操作
  actions: {
    edit: "编辑",
    save: "保存",
    delete: "删除"
  },
  
  // 占位符文本
  placeholders: {
    title: "标题",
    content: "内容"
  }
};
